import { render, staticRenderFns } from "./Analyze.vue?vue&type=template&id=28d32212&scoped=true&"
import script from "./Analyze.vue?vue&type=script&lang=js&"
export * from "./Analyze.vue?vue&type=script&lang=js&"
import style0 from "./Analyze.vue?vue&type=style&index=0&id=28d32212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d32212",
  null
  
)

export default component.exports